import React, { useEffect, useState } from "react";
import SimpleInput from "../../../Tools/SimpleInput";
import UploadImageModal from "../../../Layouts/Model/uploadImageModal";
import Cropper from "react-easy-crop";
import getCroppedImg from "../../../../data/imagefun";
import { mediaUrl } from "../../../../services/network";

const LogoTab = ({
  currentStep,
  errors,
  register,
  setValue,
  company_logo,
  getValues,
  user,
  dltLogo,
  setDltLogo,
}) => {
  const [selectedImage, setSelectedImage] = useState("");
  const [imageName, setImageName] = useState("");
  const [companyLogo, setCompanyLogo] = useState("");
  const [crop, setCrop] = useState({
    x: 0,
    y: 0,
    width: 50,
    aspect: 300 / 300,
  });
  const [zoom, setZoom] = useState(null);

  const [croppedAreaPixels, setCroppedAreaPixels] = useState({
    width: 300,
    height: 300,
    x: 0,
    y: 0,
  });

  useEffect(() => {
    if (user.company_logo) {
      const company_logo = getValues("company_logo");
      if (company_logo) {
        setCompanyLogo(`${mediaUrl}${company_logo}`);
      }
    }
  }, [currentStep]);

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageName(file.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const showCroppedImage = async () => {
    try {
      const croppedImage = await getCroppedImg(
        selectedImage,
        croppedAreaPixels,
        0
      );
      handleCompanyLogo(croppedImage);
      setSelectedImage("");
    } catch (e) {
      console.error(e);
    }
  };
  const handleCompanyLogo = (image) => {
    setValue("company_logo", image);
    setCompanyLogo(URL.createObjectURL(image));
  };

  console.log(company_logo, "company_logo");
  return (
    <div
      className="tab"
      style={{ display: currentStep === 3 ? "block" : "none" }}
    >
      <div className="form-group">
        <label>
          3. Choose Profile Logo
          <div className="dropdown">
            <a
              className="dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span>Why it is important</span> ?
            </a>
            <div className="dropdown-menu">
              <p>it will show as Profile logo on Single Page of Yours</p>
              <a
                href="../../assets/images/select2.jpg"
                data-fancybox
                className="mt-0"
              >
                <img
                  src="../../assets/images/select2.jpg"
                  class="ag-photo-gallery_img"
                  alt=""
                />
              </a>
            </div>
          </div>
        </label>
        <p>Upload logo for your profile</p>
        {!companyLogo && (
          <>
            <div className="upload">
              <SimpleInput
                style={"form-control"}
                inType={"file"}
                name={"company_logo"}
                onChange={handleChange}
                event={register}
                accept={"image/*"}
              />
              <img src="../../assets/images/uploadimg.png" alt="uploadimg" />
              <h6>Drop your files here!</h6>
              <p className="mb-0">or click</p>
            </div>
            <p>
              <b>Allowed file formats:</b> JPG, PNG Maximum file size: 10MB
            </p>
          </>
        )}
        {selectedImage && (
          <div className="select_image">
            <Cropper
              image={selectedImage}
              crop={crop}
              zoom={zoom}
              aspect={300 / 300}
              onCropChange={setCrop}
              initialCroppedAreaPercentages={croppedAreaPixels}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
            >
              <img src={selectedImage} />
            </Cropper>
            <button
              type="button"
              className="cancel_btn"
              onClick={() => setSelectedImage("")}
            >
              Cancel
            </button>
            <button onClick={showCroppedImage} type="button">
              Submit
            </button>
          </div>
        )}

        {companyLogo && (
          <>
            <div className="file">
              <img src={companyLogo} alt="" className="w-100" />
              <i
                className="bi bi-x"
                onClick={() => {
                  setSelectedImage("");
                  setCompanyLogo("");
                  setValue("company_logo", "");
                  if (company_logo) {
                    setDltLogo(company_logo);
                  }
                }}
              ></i>
            </div>
            {imageName && (
              <p>
                <b>File :</b> {imageName}
              </p>
            )}
          </>
        )}
        {errors && errors["company_logo"] && (
          <p style={{ color: "red" }}>{errors["company_logo"].message}</p>
        )}
      </div>
    </div>
  );
};

export default LogoTab;
